import 'Layouts/default';

import 'Ui/tabs';

const afterAutocompleteSelect = (autocompleteField, data) => {
    const form = autocompleteField.closest('form')
    const billing = form.querySelector('.js-b2b-reg-billing')

    if (billing) {
        billing.classList.remove('h-nodisplay')

        if (Object.values(data.result || []).length) {
            for (const input of billing.querySelectorAll('input, select')) {
                $(input).valid()
            }
        }
    }
};

const registrationBarberTrigger = document.querySelector('.js-registration-barber-trigger');

if (registrationBarberTrigger) {
    registrationBarberTrigger.addEventListener('click', () => {
        const registrationBarberWrapper = document.querySelector('.js-registration-barber-wrapper');

        if (!registrationBarberWrapper.classList.contains('is-active')) {
            registrationBarberWrapper.classList.add('is-active');
        }
    });
}

rEvent.on('Finstat.select.after', afterAutocompleteSelect);
rEvent.on('Hithorizons.select.after', afterAutocompleteSelect);
